import React from 'react'
import BaseComponent from '../components/BaseComponent'
import { GetLookHome } from '../common/ApiHelper'
import Swiper from '../components/SwiperComponent'
import Class from '../components/ClassComponent'
import Card from '../components/CardComponent'

const imgs = [
  {
    id: '1',
    src: require('../img/banner2.jpg'),
  },
  {
    id: '2',
    src: require('../img/banner2.jpg'),
  },
]

class Main extends BaseComponent {
  public state: {
    slideData: Array<{ id: string; src: string }>
    classData: Array<{ id: string; src: string; name: string }>
    recommendData: Array<{
      data: Array<{ id: string; src: string; name: string }>
      name: string
      id: string
    }>
    searchText: string
  } = {
    slideData: [],
    classData: [],
    recommendData: [],
    searchText: '',
  }
  public type = '1'
  public componentDidMount() {
    this.type = this.GetQueryString(this.props.location.search, 'type')!
    this.ShowToast()
    GetLookHome(this.type, (res) => {
      if (res.ResultCode === 2) {
        this.RemoveToast()
        this.ShowToast(res.Msg, 1, 3000)
        return
      }
      const slideData = res.Data.slideShow
        .filter((v) => v.bookType === 1)
        .map((v) => {
          return {
            id: v.bookID,
            src: v.imgUrl,
          }
        })
      const classData = res.Data.classifies.map((v) => {
        return {
          id: v.classifyID,
          src: v.imgUrl,
          name: v.name,
        }
      })
      const recommendData = res.Data.classifies.slice(0, 3).map((classifie) => {
        const items = classifie.items.map((item) => {
          return {
            id: item.bookID,
            src: item.imgUrl,
            name: item.name,
          }
        })
        return {
          id: classifie.classifyID,
          name: classifie.name,
          data: items,
        }
      })
      this.setState(
        {
          slideData: slideData,
          classData: classData,
          recommendData: recommendData,
        },
        () => {
          this.RemoveToast()
        }
      )
    })
  }
  public onMoreClick = (id: string) => {
    this.props.history.push('/Search?classifyid=' + id + '&type=' + this.type)
  }
  public onItemClick = (id: string) => {
    switch (this.type) {
      case '1':
        this.props.history.push('/Details?bookid=' + id)
        break
      case '2':
        this.props.history.push('/Listen?bookid=' + id)
        break
      case '3':
        this.props.history.push('/Video?bookid=' + id)
        break
    }
  }
  public onClassItemClick = (id: string) => {
    this.props.history.push('/Search?classifyid=' + id + '&type=' + this.type)
  }
  public Searching = () => {
    this.props.history.push(
      '/Search?keyword=' + this.state.searchText + '&type=' + this.type
    )
  }
  public SearchInputOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchText: e.currentTarget.value })
  }
  public onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      this.Searching()
    }
  }
  public render() {
    const { slideData, classData, recommendData, searchText } = this.state
    const recommendLayout = recommendData.map((data) => {
      return (
        <Card
          key={data.id}
          data={data.data}
          id={data.id}
          name={data.name}
          onItemClick={this.onItemClick}
          onMoreClick={this.onMoreClick.bind(this, data.id)}
        />
      )
    })
    return (
      <div
        className="c-box"
        style={{
          height: '100vh',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <div className="c-top1">
          <div className="c-search">
            <input
              onKeyDown={this.onKeyDown}
              value={searchText}
              type="text"
              onChange={this.SearchInputOnChange}
              placeholder="请输入图书名称"
            />
            <a>
              <img
                src={require('../img/search.png')}
                onClick={this.Searching}
              />
            </a>
          </div>
          <a className="c-shujia">
            <img src={require('../img/shujia.png')} />
          </a>
        </div>
        <Swiper data={slideData} />
        <Class data={classData} onItemClick={this.onClassItemClick} />
        {recommendLayout}
        <div className="c-h305"></div>
      </div>
    )
  }
}

export default Main
